<div class="page-header flex flex-row px-4 py-2 gap-2">
  <div class="flex-1 bm-breadcrumbs text-sm">
    <ul class="m-0 p-0">
      <li>
        <a [routerLink]="['/']">Home</a>
      </li>
      <li>
        <a [routerLink]="['/', 'ticket', 'suche', 'index']">
          <i class="fa fa-ticket"></i>
          Tickets
        </a>
      </li>
      <li>Einsätze</li>
    </ul>
  </div>

  <div class="flex flex-row gap-2">
    <input type="text" class="bm-join-item bm-input" (input)="quicksearchChanged($event)" placeholder="Schnellfilter" />
    <a class="bm-join-item bm-btn bm-btn-primary bm-btn-square" [cdkMenuTriggerFor]="tplMenu">
      <i class="fa fa-bars"></i>
    </a>
    <ng-template #tplMenu>
      <ul
        cdkMenu
        class="bm-menu bm-dropdown-content bg-primary text-primary-content rounded-box z-1 w-52 shadow-sm p-0 m-0 mt-1"
      >
        <li class="bm-divider m-0 p-0 h-0 bm-divider-secondary"></li>
        <li>
          <a (click)="saveState()">
            <i class="fa fa-save"></i>
            Config speichern
          </a>
        </li>
        <li>
          <a (click)="deleteState()">
            <i class="fa fa-ban"></i>
            Config löschen
          </a>
        </li>
      </ul>
    </ng-template>
  </div>
</div>
<div class="page-content px-4 pb-2">
  <ag-grid-angular
    class="ag-theme-quartz h-full shadow"
    [rowData]="data"
    [getRowId]="getRowId"
    [theme]="hawkTheme"
    [loadThemeGoogleFonts]="true"
    [theme]="hawkTheme"
    [loadThemeGoogleFonts]="true"
    [defaultColDef]="defaultColDef"
    [columnDefs]="colDefs"
    [rowClassRules]="rowClassRules"
    [pagination]="true"
    [rowSelection]="rowSelection"
    [initialState]="initialState"
    [paginationPageSize]="100"
    [localeText]="locale"
    [sideBar]="sideBarOptions"
    [paginationPageSizeSelector]="[50, 100, 300, 1000, 9000]"
    (gridReady)="onGridReady($event)"
  />
</div>

@if (bulkExcelState(); as state) {
  <hawk-operations-bulk-excel
    [operationIds]="state.operationIds"
    [projectId]="state.projectId"
    (closeDialog)="closeBulkExcel()"
    (imported)="onBulkExcelImported()"
  />
}
